import React from 'react';
import classNames from 'classnames';

import '../styles/global.scss';

import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import TrendArrow from '../images/svg/trend_arrow.svg';

function CSRModule({ csr, reverseLayout }) {
  return (
    <div
      className={classNames({
        'w-full flex lg:flex-row flex-col': true,
        'flex-row-reverse': reverseLayout,
      })}
    >
      <div className='lg:w-1/2 w-full flex-col'>
        <div className='bg-white px-3 lg:px-10 pb-5 lg:pb-10 flex flex-col justify-end'>
          <div className='text-slate-900 text-2xl lg:text-5xl font-bold pt-4 lg:pt-20'>
            Challenge
          </div>
          <p className='text-teal-950 text-xs lg:text-base font-normal mt-2 lg:mt-6'>
            {csr.challengeText}
          </p>
        </div>
        <div className='bg-secondary-light px-3 pb-5 lg:px-10 lg:pb-10 flex flex-col justify-end'>
          <div className='text-white text-2xl lg:text-5xl font-bold pt-4 lg:pt-20'>Solution</div>
          <p className='text-white text-xs lg:text-base font-normal mt-2 lg:mt-6'>
            {csr.solutionText}
          </p>
        </div>
      </div>
      <div className='lg:w-1/2 w-full bg-zinc-300'>
        <div className='h-1/2 lg:flex items-start justify-end hidden px-3 lg:px-10 lg:pb-10'>
          {csr.positive ? (
            <TrendArrow className='csr_arrow' />
          ) : (
            <TrendArrow className='csr_arrow rotate-180' />
          )}
          <h2 className='text-slate-900 lg:text-[128px] text-[24px] font-bold text-right'>
            {csr.result}
          </h2>
        </div>
        <div className='h-1/2 px-3 lg:px-10 pb-5 lg:pb-10 flex flex-col justify-end'>
          <div className='text-slate-900 text-2xl lg:text-5xl pt-4 font-bold flex flex-row justify-between'>
            <span>Result</span>
            <span className='text-slate-900 text-[24px] font-bold text-right lg:hidden'>
              {csr.positive ? (
                <KeyboardArrowUp className='csr_arrow text-secondary-light font-extrabold' />
              ) : (
                <KeyboardArrowDown className='csr_arrow text-secondary-light font-extrabold' />
              )}
              {csr.result}
            </span>
          </div>
          <p className='text-teal-950 text-xs lg:text-base font-normal mt-2 lg:mt-6'>
            {csr.resultText}
          </p>
        </div>
      </div>
    </div>
  );
}

export default CSRModule;
